export enum NetworkRoles {
  request = 'request',
  admin = 'admin',
  member = 'member',
  invite = 'invite',
  none = 'none'
}
